<template>
  <div class="zch-side">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ZchSide'
}
</script>